@if (tiles.length) {
  <div class="treemap">
    @for (tile of tiles; track tile.ticker + $index) {
      <div
        class="tm-cell"
        [class.small]="tile.small"
        [class.tiny]="tile.tiny"
        [class.strong]="tile.strong"
        [style.left.%]="tile.x"
        [style.top.%]="tile.y"
        [style.width.%]="tile.w"
        [style.height.%]="tile.h"
        [style.background]="tile.background"
        [matTooltip]="tile.full"
      >
        <div class="tm-ticker">{{ tile.ticker }}</div>
        @if (!tile.tiny) {
          <div class="tm-val">{{ tile.label }}</div>
        }
      </div>
    }
  </div>
}
